<div class="l-top-navi">
  <div class="l-wrap l-wrap--sp-tb-full">
    <div class="l-wrap__inner">
      <div class="l-top-navi__inner l-top-navi__inner--has-progress">
        <div class="l-top-navi__back-area">
          <a
            id="roundtrip-flight-availability-international-sub-header-back3"
            class="l-top-navi__back-link"
            href="#"
            (click)="clickBack($event)"
          >
            <span class="u-visually-hidden" [innerHTML]="'reader.goBackToPreviousPage' | staticMsg"></span>
          </a>
        </div>
        <div class="l-top-navi__heading-area">
          <h1 class="l-top-navi__heading-text" [innerHTML]="'label.searchResult.title' | staticMsg"></h1>
        </div>
        <!-- [ヘッダー下メニュー ボタンエリア] SP・TAB表示時の読み上げ対策用-->
        <ng-container *ngIf="!isPC">
          <div class="l-top-navi__function-area">
            <div class="l-top-navi__function-item">
              <button
                id="roundtrip-flight-availability-international-sub-header-research2"
                class="l-top-navi__function-btn l-top-navi__function-btn--modify"
                (throttleClick$)="openReSearchModal()"
                aswThrottleClick
              >
                <span class="l-top-navi__function-btn-text" [innerHTML]="'label.searchChange' | staticMsg"></span>
              </button>
            </div>
          </div>
        </ng-container>
        <!-- //[ヘッダー下メニュー ボタンエリア] -->

        <!-- [ステップナビゲーション] -->
        <div class="l-top-navi__progress-area">
          <ol class="l-top-navi__progress-list" [attr.aria-label]="'reader.breadcrumb.navigation' | staticMsg">
            <li class="l-top-navi__progress-item l-top-navi__progress-item--active l-top-navi__progress-item--current">
              <div class="l-top-navi__progress-wrap">
                <span
                  *ngIf="isPC"
                  class="u-visually-hidden"
                  [innerHTML]="'reader.breadcrumb.current' | staticMsg"
                ></span>
                <span
                  *ngIf="isSP || isTB"
                  class="u-visually-hidden"
                  [innerHTML]="'alt.stepBar' | staticMsg : { '0': this.stepNum, '1': this.currentStepNum }"
                ></span>
                <span class="l-top-navi__progress-num" [innerHTML]="'label.breadcrumb.first' | staticMsg"></span>
                <span class="l-top-navi__progress-text" [innerHTML]="'label.flightSearch' | staticMsg"></span>
              </div>
            </li>
            <li class="l-top-navi__progress-item">
              <em class="l-top-navi__progress-wrap">
                <span class="l-top-navi__progress-num" [innerHTML]="'label.breadcrumb.second' | staticMsg"></span>
                <span
                  class="l-top-navi__progress-text"
                  [innerHTML]="'label.passengerInformationInput' | staticMsg"
                ></span>
              </em>
            </li>
            <li class="l-top-navi__progress-item">
              <div class="l-top-navi__progress-wrap">
                <span class="l-top-navi__progress-num" [innerHTML]="'label.breadcrumb.third' | staticMsg"></span>
                <span class="l-top-navi__progress-text" [innerHTML]="'label.suchAsSeatAssign' | staticMsg"></span>
              </div>
            </li>
            <li class="l-top-navi__progress-item">
              <div class="l-top-navi__progress-wrap">
                <span class="l-top-navi__progress-num" [innerHTML]="'label.breadcrumb.fourth' | staticMsg"></span>
                <span class="l-top-navi__progress-text" [innerHTML]="'label.purchase2' | staticMsg"></span>
              </div>
            </li>
            <li class="l-top-navi__progress-item">
              <div class="l-top-navi__progress-wrap">
                <span class="l-top-navi__progress-num" [innerHTML]="'label.breadcrumb.fifth' | staticMsg"></span>
                <span class="l-top-navi__progress-text" [innerHTML]="'label.complete' | staticMsg"></span>
              </div>
            </li>
          </ol>
        </div>
        <!-- //[ステップナビゲーション] -->
        <!-- [ヘッダー下メニュー ボタンエリア] PC表示時の読み上げ対策用-->
        <ng-container *ngIf="isPC">
          <div class="l-top-navi__function-area">
            <div class="l-top-navi__function-item">
              <button
                id="roundtrip-flight-availability-international-sub-header-research1"
                class="l-top-navi__function-btn l-top-navi__function-btn--modify"
                (throttleClick$)="openReSearchModal()"
                aswThrottleClick
              >
                <span class="l-top-navi__function-btn-text" [innerHTML]="'label.searchChange' | staticMsg"></span>
              </button>
            </div>
          </div>
        </ng-container>
        <!-- //[ヘッダー下メニュー ボタンエリア] -->
      </div>
    </div>
  </div>
</div>
